import { Autorenew, Search } from "@mui/icons-material";
import { Button, FormLabel, IconButton, InputAdornment, TextField } from "@mui/material";
import ButtonDropDown from "../../../components/general/ButtonDropDown";
import { useState } from "react";
import { FILTER_TYPE } from "../../../helper/Constant";

function Filter({ RunFilter, FilterTypeSudah, FilterTypeBelum }) {
    const [filterNoReg, setFilterNoReg] = useState('');
    const [filterNama, setFilterNama] = useState('');
    const [openSudah, setOpenSudah] = useState(false);
    const [openBelum, setOpenBelum] = useState(false);


    const handleMenuSudahItemClick = (option, setOpen) => {
        RunFilter(option.name, "1");
        setOpen(false);
    };

    const handleMenuBelumItemClick = (option, setOpen) => {
        RunFilter(option.name, "0");
        setOpen(false);
    };

    const handleToggle = (setOpen) => {
        setOpen((prevOpen) => !prevOpen);
    };

    return (
        <>
            <div style={{ marginBottom: "10px" }}>
                <FormLabel sx={{ mb: "10px" }} component="legend">Filter Berdasarkan:&nbsp;</FormLabel>
                <TextField
                    onChange={(e) => { setFilterNoReg(e.target.value); }}
                    label="No Reg"
                    size="small"
                    value={filterNoReg}
                    variant="outlined"
                    sx={{ mr: "10px" }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => {
                                    RunFilter("no_daftar", filterNoReg);
                                }}>
                                    <Search />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}></TextField>
                <TextField
                    onChange={(e) => { setFilterNama(e.target.value); }}
                    label="Nama"
                    value={filterNama}
                    size="small"
                    sx={{ mr: "10px" }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => {
                                    RunFilter("nama", filterNama);
                                }}>
                                    <Search />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }} />
                <ButtonDropDown setOpen={setOpenSudah} buttonOptions={FilterTypeSudah} open={openSudah} handleClose={setOpenSudah} handleToggle={handleToggle} handleMenuItemClick={handleMenuSudahItemClick}></ButtonDropDown>
                <ButtonDropDown setOpen={setOpenBelum} buttonOptions={FilterTypeBelum} open={openBelum} handleClose={setOpenBelum} handleToggle={handleToggle} handleMenuItemClick={handleMenuBelumItemClick}></ButtonDropDown>
                <Button onClick={() => {
                    setFilterNoReg("");
                    setFilterNama("");
                    RunFilter("", "");
                }} variant="outlined" startIcon={<Autorenew></Autorenew>}>Reset Filter</Button>
            </div>
        </>
    )
}

export default Filter;